module.exports = __webpack_public_path__ + "img/arrow-answer.63f05cc6.svg";